import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    /**
     * Enthält alle Child-Elemente.
     */
    children?: JSX.Element | JSX.Element[],

    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Inline-Style für den Content Wrapper.
     */
    contentStyle?: React.CSSProperties,

    /**
     * Die Überschrift der GroupBox.
     */
    headerText?: string,

    /**
     * Benutzerdefinierte Margin Eigenschaft für die Überschrift.
     */
    headerMargin?: {
        left?: number,
        right?: number,
        bottom?: number
    };
}

export class GroupBox extends React.Component<IProperties>
{
    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        var { children, style, contentStyle, headerText, headerMargin } = this.props;

        var headerStyle: any;
        if (headerMargin != null)
        {
            headerStyle = {
                marginLeft: headerMargin.left,
                marginRight: headerMargin.right,
                marginBottom: headerMargin.bottom
            };
        }

        return (
            <div
                className="groupbox"
                style={style}>
                {
                    headerText &&
                    <div
                        className="groupbox_header"
                        style={headerStyle}>
                        <span className="groupbox_header_text">{headerText}</span>
                    </div>
                }
                <div
                    style={contentStyle}
                    className="groupbox_content">
                    {children}
                </div>
            </div>
        );
    }
}